import TimedDetails from './timedDetails'

export default TimedDetails
